// extracted by mini-css-extract-plugin
export var root = "Container-module--root--QqjIn";
export var sectionContainer = "Container-module--sectionContainer--xOAkA";